<template>
  <div class="media" :class="{_error: Boolean(file.error)}">
    <i class="fa fa-3x mr-3 align-self-center" :class="{[getFileIconClass(file)]: true}"></i>
    <div class="media-body align-self-center">
      <h5 class="mt-0 mb-0">
        {{ getDisplayType(file) }}
      </h5>
      <Progress class="_progress" v-if="file.active" :max="100" :value="parseFloat(file.progress)" />
      <div v-if="Boolean(file.error)">
        Échec de l'envoi
      </div>
      <div v-if="!file.active && !Boolean(file.error) && isDeletable">
        <button @click.prevent="$emit('delete', file)" class="btn btn-danger btn-sm"><i class="fa fa-trash-alt"></i></button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  ._progress {
    max-width: 20rem;
  }
  ._details {
    margin-left: 3rem;
  }
  ._error {
    color: #dc3545;
  }
</style>

<script>
  import Progress from "@/components/Progress";

  const knownFileTypes = {
    'audio/mpeg': { title: 'Audio', icon: 'file-audio' },
    'application/pdf': { title: 'PDF', icon: 'file-pdf' },
    'text/plain': { title: 'Paroles', icon: 'file-alt' },
    'text/chopro': { title: 'ChordPro', icon: 'file' }
  };

  export default {
    components: {
      Progress
    },
    props:{
      file: {
        type: Object
      },
      isDeletable: {
        type: Boolean,
        default: () => true
      }
    },
    computed: {
      isUploading() {
        return true;
      }
    }, 
    methods: {
      getDisplayType(file) {
        return (
          knownFileTypes[file.type]?.title
          || knownFileTypes[file.name.split('.').pop()]?.title
          || '<Type de fichier non reconnu>'
        );
      },
      getFileIconClass(file) {
        return 'fa-' + (
          knownFileTypes[file.type]?.icon
          || knownFileTypes[file.name.split('.').pop()]?.icon
          || 'file'
        );
      }
    }
  }
</script>